import React from 'react';
import { useFormContext } from 'react-hook-form';
import useToggle from '../../hooks/useToggle';
import useComponentMargin from '../../hooks/useComponentMargin';
import withFormErrors from '../../hocs/withFormErrors';
import LabeledFieldset from '../LabeledFieldset';
import InputError from '../InputError';
import Button from '../Button';
export const RadioGroup = ({ name, displayName, children, disabled = false, required = false, noBorders = false, initiallyShow, errorId, errorMessage, styles, className }) => {
    const [extended, setExtendedOn] = useToggle();
    const methods = useFormContext();
    const checkedValue = methods.watch(name);
    const processedChildren = React.Children.map(children, (child) => (React.createElement(child.type, { ...child, ...child.props, name: name, disabled: disabled, checkedValue: checkedValue })));
    const shouldProceedInitiallyShow = initiallyShow && !extended && React.Children.count(processedChildren) > 5;
    const processedChildrenFinal = () => {
        if (shouldProceedInitiallyShow && initiallyShow) {
            const newArray = React.Children.toArray(processedChildren);
            return newArray.slice(0, initiallyShow - 1);
        }
        else
            return processedChildren;
    };
    const seeMoreMargins = useComponentMargin({ marginBottom: 'regular' });
    const mergedStyles = {
        width: '100%',
        ...styles
    };
    return (React.createElement("div", null,
        React.createElement(LabeledFieldset, { name: name, displayName: displayName, required: required, disabled: disabled, noBorders: noBorders, hasErrors: !!errorMessage, styles: mergedStyles, initiallyShow: !!shouldProceedInitiallyShow, className: className }, processedChildrenFinal()),
        shouldProceedInitiallyShow && (React.createElement(Button, { onClick: setExtendedOn, variant: "secondary", size: "small", noDefaultMargin: true, styles: seeMoreMargins }, "See more")),
        errorId && React.createElement(InputError, { id: errorId }, errorMessage)));
};
export default withFormErrors(RadioGroup);
//# sourceMappingURL=index.js.map